// Analytics Service for Google Analytics event tracking
export class AnalyticsService {
  static isEnabled() {
    return typeof window !== 'undefined' && window.gtag;
  }

  static trackEvent(eventName, parameters = {}) {
    if (this.isEnabled()) {
      window.gtag('event', eventName, parameters);
    }
  }

  static trackPageView(page_title, page_location) {
    if (this.isEnabled()) {
      window.gtag('config', 'G-EHYCCYXEV8', {
        page_title,
        page_location
      });
    }
  }

  // Lawn care specific events
  static trackTaskCompletion(taskType, month, zone) {
    this.trackEvent('task_completed', {
      task_type: taskType,
      month: month,
      hardiness_zone: zone,
      event_category: 'lawn_care'
    });
  }

  static trackStateSelection(state, zone) {
    this.trackEvent('state_selected', {
      state: state,
      hardiness_zone: zone,
      event_category: 'location'
    });
  }

  static trackPhotoUpload(photoType) {
    this.trackEvent('photo_uploaded', {
      photo_type: photoType,
      event_category: 'engagement'
    });
  }

  static trackSettingsChange(settingType, value) {
    this.trackEvent('settings_changed', {
      setting_type: settingType,
      setting_value: value,
      event_category: 'configuration'
    });
  }

  static trackPerformanceView() {
    this.trackEvent('performance_viewed', {
      event_category: 'engagement'
    });
  }

  static trackMonthNavigation(month) {
    this.trackEvent('month_navigated', {
      month: month,
      event_category: 'navigation'
    });
  }

  static trackPWAInstall() {
    this.trackEvent('pwa_installed', {
      event_category: 'app_engagement'
    });
  }

  static trackWeatherAlert(alertType) {
    this.trackEvent('weather_alert_viewed', {
      alert_type: alertType,
      event_category: 'weather'
    });
  }
}